import React, { MouseEvent } from 'react';

import { Button, SvgIcon } from '@infoods/lifebase-ui';

import { ReactComponent as ChatIcon } from '../../../../../../assets/images/tabs/communication.svg';
import { communicationModalStore } from '../../../../chat/stores/communicationModalStore';
import { SendMessageResourceType } from '../../../../chat/interfaces/SendMessageData';

type CustomerContactLinkProps = {
  customerId: number;
  resourceType: SendMessageResourceType;
  className?: string;
};

const CustomerContactLink = ({
  customerId,
  resourceType,
  className,
}: CustomerContactLinkProps) => {
  const handleOpenSendMessageDialog = (event: MouseEvent) => {
    event.stopPropagation();

    communicationModalStore.openCommunicationModal({
      customerIds: [customerId],
      customersCount: 1,
      resourceType,
    });
  };

  return (
    <Button
      className={className}
      variant="link"
      disableRipple
      onClick={handleOpenSendMessageDialog}
    >
      <SvgIcon component={ChatIcon} inheritViewBox fontSize="extraLarge" />
      <span>Contact</span>
    </Button>
  );
};

export { CustomerContactLink };
